export function estimatePublishTimeRemaining(options: {
	totalPhotos: number
	finishedPhotos: number
	uploadedPhotos: number
	elapsedSeconds: number
	uploadConcurrency: number
}) {
	const { totalPhotos, finishedPhotos, uploadedPhotos, elapsedSeconds, uploadConcurrency } =
		options
	const remainingPhotos = Math.max(0, totalPhotos - finishedPhotos)

	if (remainingPhotos === 0) {
		return 0
	}

	const minimumSampleSize = Math.min(totalPhotos, uploadConcurrency)
	if (
		uploadedPhotos < minimumSampleSize ||
		elapsedSeconds <= 0 ||
		!Number.isFinite(elapsedSeconds)
	) {
		return Number.NaN
	}

	return (remainingPhotos * elapsedSeconds) / uploadedPhotos
}
